"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3AuthWrapper = exports.webAuthSlice = void 0;
const react_1 = __importDefault(require("react"));
const Connect_1 = require("unifyre-extension-web3-retrofit/dist/contract/Connect");
const react_redux_1 = require("react-redux");
const AppState_1 = require("../store/AppState");
const types_1 = require("types");
const toolkit_1 = require("@reduxjs/toolkit");
const ApiClient_1 = require("./../clients/ApiClient");
exports.webAuthSlice = toolkit_1.createSlice({
    name: 'webAuthSlice',
    initialState: {
        address: '',
        email: ''
    },
    reducers: {
        addressInfoFetched: (state, action) => {
            state.address = action.payload.address,
                state.email = action.payload.email;
        }
    }
});
const Actions = exports.webAuthSlice.actions;
const connect = toolkit_1.createAsyncThunk('connect', async (payload, ctx) => {
    var _a;
    const api = types_1.inject(ApiClient_1.ApiClient);
    //@ts-ignore
    await window.ethereum.enable();
    const connect = types_1.inject(Connect_1.Connect);
    const connection = await ((_a = connect.getProvider()) === null || _a === void 0 ? void 0 : _a.web3());
    const accounts = await (connection === null || connection === void 0 ? void 0 : connection.eth.getAccounts());
    const publicAddress = await (connection === null || connection === void 0 ? void 0 : connection.eth.getCoinbase()) || '';
    const res = await api.authenticateAddress(publicAddress);
    if (!res.status) {
        const sign = await (connection === null || connection === void 0 ? void 0 : connection.eth.personal.sign(connection.utils.fromUtf8(`This signature verifies that you are the authorized owner of the wallet. The signature authentication is required to ensure allocations are awarded to the correct wallet owner. [Signature Nonce:${res.nonce}]`), publicAddress, 'test'));
        if (sign) {
            const response = await api.verifySignature(sign || '', { nonce: res.nonce, address: publicAddress });
            ctx.dispatch(Actions.addressInfoFetched(response.info));
        }
        return;
    }
    ctx.dispatch(Actions.addressInfoFetched(res.info));
    return res;
});
function Web3AuthWrapper(props) {
    const dispatch = react_redux_1.useDispatch();
    const connected = react_redux_1.useSelector(state => { var _a, _b; return !!((_b = (_a = state.connection.account) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId); });
    const address = react_redux_1.useSelector(state => { var _a; return AppState_1.addressForUser((_a = state.connection.account) === null || _a === void 0 ? void 0 : _a.user); });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(props.View, { connected: connected, network: (address === null || address === void 0 ? void 0 : address.network) || '', onClick: () => { dispatch(connect({})); } })));
}
exports.Web3AuthWrapper = Web3AuthWrapper;
//# sourceMappingURL=Web3UserAuthWrapper.js.map